import { apiFailure } from '@/lib/apiFailure'

/** "5 minutes" for a wait in milliseconds, rounded up to whole seconds, minutes or hours; null without a wait. */
export function waitWords(ms: number | null | undefined): string | null {
  if (!ms || !Number.isFinite(ms) || ms <= 0) return null
  const seconds = Math.ceil(ms / 1000)
  const [value, unit]: [number, string] =
    seconds < 60 ? [seconds, 'second'] : seconds < 3600 ? [Math.ceil(seconds / 60), 'minute'] : [Math.ceil(seconds / 3600), 'hour']
  return new Intl.NumberFormat('en', { style: 'unit', unit, unitDisplay: 'long' }).format(value)
}

/** The wait a rejected API call's Retry-After asks for, in words ("1 hour"), or null without a usable header. */
export function retryWait(error: unknown): string | null {
  return waitWords(apiFailure(error).retryAfterMs)
}
